import React from 'react';
import Icon from '../Icon';

export default function EmptyState(props) {
  const { text, icon } = props;

  return (
    <div className='km__c--empty-state-container'>
      <Icon name={icon} size='24' />
      <div className='km__c--empty-state-text'>{text}</div>
    </div>
  );
}
